import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const HourFactorTable = ({ factors, onChange }) => {
    let headers = [];
    let rows = [];

    for(let i = 0; i < 24; i++) headers.push(<th>{i}</th>);

    for(let k = 0; k < 7; k++) {
        const dayFactors = factors[k] ? factors[k] : {};
        rows.push(<Row day={k} factors={dayFactors} onChange={onChange}/>);
    }

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
            <tr>
                <th>Day/Hour</th>
                {headers}
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </Table>
    )
};

export default HourFactorTable;



// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/DummyHourFactor/components/Table/index.js